import { FILE_DATA, LOADER_STATUS, SAVE_TOTAL_PAGES, SET_ENTITY_LIST, SET_SELECTED_ENTITY } from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    totalPages: 1,
    entityList: [],
    selectedEntity: "",
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr6UploadReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
        case FILE_DATA:
          return {
            ...state,
            fileData:action.fileData
          }
        case SAVE_TOTAL_PAGES:
          return {
            ...state,
            totalPages:action.pages
          }
        case SET_ENTITY_LIST:
          return {
            ...state,
            entityList: action.payload,
          };
        case SET_SELECTED_ENTITY:
          return {
            ...state,
            selectedEntity: action.payload,
          };
        
        default:
          return state;
      }
    };
  
  export default gstr6UploadReducer;